import { createSlice } from "@reduxjs/toolkit"

const slice = createSlice({
    name: 'supplier',
    initialState: {
        supplier: '',
        suppliers: {
            list: [],
            offset: 0,
            limit: 10,
            count: 0,
            query: '',
        },
    },
    reducers: {
        setSupplier(state, action) {
            state.supplier = action.payload
        },
        setSuppliersList(state, action) {
            state.suppliers.list = action.payload
        },
        setSuppliersOffset(state, action) {
            state.suppliers.offset = action.payload
        },
        setSuppliersLimit(state, action) {
            state.suppliers.limit = action.payload
        },
        setSuppliersCount(state, action) {
            state.suppliers.count = action.payload
        },
        setSuppliersQuery(state, action) {
            state.suppliers.query = action.payload
        },
        addSupplier(state, action) {
            state.suppliers.list.unshift(action.payload)
        },
        addSupplierUser(state, action) {
            if (state.supplier) {
                state.supplier['user'] = action.payload
            }
            // state.supplier.list.unshift(action.payload)
        },
        setSupplierPayment(state, action) {
            if (state.supplier) {
                state.supplier['payments'] = [action.payload]
            }
            // state.supplier.list.unshift(action.payload)
        },
        addSupplierContact(state, action) {
            if (state.supplier) {
                if (state.supplier['contacts']) {
                    state.supplier['contacts'].unshift(action.payload)
                } else {
                    state.supplier['contacts'] = [action.payload]
                }
            }
            // state.supplier.list.unshift(action.payload)
        },
        editSupplierContact(state, action) {
            if (state.supplier) {
                if (state.supplier['contacts']) {
                    state.supplier['contacts'] = state.supplier['contacts'].map(contact => {
                        if (contact.id === action.payload.id) {
                            return action.payload
                        } else {
                            return contact
                        }
                    })
                    // state.supplier['deliveries'].unshift(action.payload)
                } else {
                    state.supplier['contacts'] = [action.payload]
                }
            }
            // state.supplier.list.unshift(action.payload)
        },
        addSupplierPayment(state, action) {
            if (state.supplier) {
                if (state.supplier['payments']) {
                    state.supplier['payments'].unshift(action.payload)
                } else {
                    state.supplier['payments'] = [action.payload]
                }
            }
            // state.supplier.list.unshift(action.payload)
        },
        addSupplierDeliveries(state, action) {
            if (state.supplier) {
                if (state.supplier['deliveries']) {
                    state.supplier['deliveries'].unshift(action.payload)
                } else {
                    state.supplier['deliveries'] = [action.payload]
                }
            }
            // state.supplier.list.unshift(action.payload)
        },
        editSupplierDelivery(state, action) {
            if (state.supplier) {
                if (state.supplier['deliveries']) {
                    state.supplier['deliveries'] = state.supplier['deliveries'].map(delivery => {
                        if (delivery.id === action.payload.id) {
                            return action.payload
                        } else {
                            return delivery
                        }
                    })
                    // state.supplier['deliveries'].unshift(action.payload)
                } else {
                    state.supplier['deliveries'] = [action.payload]
                }
            }
            // state.supplier.list.unshift(action.payload)
        },
        editSupplierItems(state, action) {
            if (state.supplier) {
                state.supplier['items'] = action.payload
            }
            // state.supplier.list.unshift(action.payload)
        },
        
        editSupplierIsAgreeLawer(state, action) {
            if (state.supplier) {
                state.supplier['isAgreeLawyer'] = action.payload
            }
        },
        editSupplierDisagreeLawyerText(state, action) {
            if (state.supplier) {
                state.supplier['disagreeLawyerText'] = action.payload
            }
        },
        editSupplierIsAgreeSecurity(state, action) {
            if (state.supplier) {
                state.supplier['isAgreeSecurity'] = action.payload
            }
        },
        editSupplierDisagreeSecurityText(state, action) {
            if (state.supplier) {
                state.supplier['disagreeSecurityText'] = action.payload
            }
        },
    }
})

export default slice.reducer

export const {
    setSupplier,
    setSuppliersList,
    setSuppliersOffset,
    setSuppliersLimit,
    setSuppliersCount,
    setSuppliersQuery,
    addSupplier,
    addSupplierUser,
    addSupplierContact,
    editSupplierContact,
    setSupplierPayment,
    addSupplierPayment,
    addSupplierDeliveries,
    editSupplierDelivery,
    editSupplierItems,

    editSupplierIsAgreeLawer,
    editSupplierDisagreeLawyerText,
    editSupplierIsAgreeSecurity,
    editSupplierDisagreeSecurityText
} = slice.actions